/**
 * The edit-mode "New Org Part" quick action (desktop side toolbar + phone tools sheet) opens the
 * Organization Hierarchy dialog, which shows an EMPTY tree on Flash's 341-part board (sandbox
 * click-through, 2026-10-23). Withdrawn for the go-live: Edit Org Board covers creating parts.
 * The dialog itself is untouched — flip this back once it renders a real board.
 */
export const NEW_ORG_PART_QUICK_ACTION = false;
